import { $div } from "../utilities/TurboDom";

export class NodeLoadingLayout {
	DOM = {};

	constructor() {
		this.initDom();
		// this.hide()
	}

	initDom() {
		this.DOM.loader = $div("loading");
		this.DOM.loader.innerHTML =
			'<div class="sk-chase">\
		          <div class="sk-chase-dot"></div>\
		          <div class="sk-chase-dot"></div>\
		          <div class="sk-chase-dot"></div>\
		          <div class="sk-chase-dot"></div>\
		          <div class="sk-chase-dot"></div>\
		          <div class="sk-chase-dot"></div>\
		      </div>';
		this.DOM.loader.style.display = "none";
	}

	domElement() {
		return this.DOM.loader;
	}

	hide() {
		this.domElement().style.display = "none";
	}

	show() {
		this.domElement().style.display = "flex";
	}
}
